import { render } from "./IActionLinks.vue?vue&type=template&id=64e6d006"
import script from "./IActionLinks.vue?vue&type=script&lang=js"
export * from "./IActionLinks.vue?vue&type=script&lang=js"

import "./IActionLinks.vue?vue&type=style&index=0&id=64e6d006&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__